import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import HomePageCards from "@midland-industries/Components/HomePage/HomePageCards";
import Industries from "@midland-industries/Components/HomePage/Industries";
import PopularCategories from "@midland-industries/Components/HomePage/PopularCategories";
import Trusted from "@midland-industries/Components/HomePage/Trusted";
import Stack from "@midland-industries/Components/Stack";
import { colors } from "@midland-industries/Styles/colors";
import React, { FC } from "react";

const CustomHomePage: FC<WidgetProps> = ({ id }) => {
    return (
        <div style={{ background: colors.accent }}>
            <div style={{ maxWidth: 1112, margin: "0 auto", paddingBottom: 90 }}>
                <Zone contentId={id} zoneName="InfoSlideShow" />
                <Stack gap={90}>
                    <HomePageCards />
                    <PopularCategories />
                    <Zone contentId={id} zoneName="NewProductAnnouncements" />
                    <Stack gap={15}>
                        <Typography size={24} color={colors.textAccent} transform="uppercase">
                            Our Brands
                        </Typography>
                        <Zone contentId={id} zoneName="Brands" />
                    </Stack>
                </Stack>
            </div>
            <Trusted />
            <Industries />
        </div>
    );
};

const customHomePage: WidgetModule = {
    component: CustomHomePage,
    definition: {
        displayName: "Custom Home Page",
        group: "Common",
    },
};

export default customHomePage;
